import { useTranslation } from 'react-i18next'
import { getContrastColor } from 'components/data/LabelChip/utils'
import { Translation } from 'types/Translation'
import * as Styled from './LabelChip.styles'

interface LabelChipProps {
  name: string
  color: string
  nameTranslations: Translation[]
  inSelect?: boolean
  small?: boolean
  clickable?: boolean
  marginRight?: number
}

const LabelChip = ({
  name,
  color,
  nameTranslations,
  inSelect = false,
  small = false,
  clickable = false,
  marginRight,
}: LabelChipProps) => {
  const {
    i18n: { language: userLanguageBrowserCode },
  } = useTranslation()

  return (
    <Styled.LabelChip
      label={
        nameTranslations.find(({ languageCode }) => languageCode === userLanguageBrowserCode)
          ?.value || name
      }
      $backgroundColor={color}
      $color={getContrastColor(color)}
      $inSelect={inSelect}
      $marginRight={marginRight}
      size={small ? 'small' : 'medium'}
      clickable={clickable}
    />
  )
}

export { LabelChip }
